(function () {
    'use strict';

    angular
        .module('notificationsPlatform')
        .config(notificationsPlatformRoute);

    notificationsPlatformRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function notificationsPlatformRoute ($stateProvider) {
        $stateProvider
            .state ('root.notifications', {
                url: '/notifications',
                views: {
                    'inner-view@root': {
                        templateUrl: 'templates/notifications/reportFilter.html',
                        controller: 'NotificationsController',
                        controllerAs: 'notificationsCtrl'
                    }
                }
            });
    }
})();